import { css } from '@emotion/react';

const makeNewsletterConsentStatementStyles = ({ theme }) => {
  return {
    privacyPolicyContainer: css({
      marginTop: 10,
      maxWidth: 400,
      margin: '10px auto 15px auto',
      '& p': {
        textAlign: 'center',
      },
      '& a': {
        textDecoration: 'underline',
        color: '#00F',
        cursor: 'pointer',
      },
      '& p span': {
        fontSize: `${theme.mvf.fontSize.originalTiny}px !important`,
        [theme.breakpoints.up('tabletSmall')]: {
          fontSize: `${theme.mvf.fontSize.originalLittle}px !important`,
        },
      },
    }),
  };
};

export default makeNewsletterConsentStatementStyles;
